import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
const getDataTestCenter = 'data-test-center';
const postDataTestCenterUrl = 'data-test-center';
const putDataTestCenter = 'data-test-center/';
const deleteDataTestCenter = 'data-test-center/';
const exportDataTestCenter = 'data-test-center-export';

class DataTestCenterServices {
    getDetailTestCenter(idTc) {
        return axios.get(
            // API_URL + getDataTestCenter + '?page=' + currentPage + 'size=5',
            API_URL + getDataTestCenter + '/' + idTc,
            {
                headers: authHeader()
            });
    }

    getDataTestCenter(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getDataTestCenter + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }

    postDataTestCenter(formData) {
        return axios.post(
            API_URL + postDataTestCenterUrl, formData,
            {
                headers: authHeader()
            }
        );
    }

    putDataTestCenter(formData) {
        return axios.put(
            API_URL + putDataTestCenter + formData.idTc, formData,
            {
                headers: authHeader()
            }
        );
    }

    deleteDataTestCenter(formData) {
        // var headers = aut/hHeader();

        return axios.delete(
            API_URL + deleteDataTestCenter + formData,
            {
                headers: authHeader()
            }
        );
    }

    exportDataTestCenter() {
        return axios.get(API_URL + exportDataTestCenter, {
            headers: authHeader(),
            responseType: 'blob',        
        });
    }

}

export default new DataTestCenterServices();